/** Thin client for /api/v2 (same origin; the session is an httpOnly cookie). */

export interface ApiErrorBody { error: { code: string; message: string; details?: Array<{ path: string; message: string }> } }

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  constructor(status: number, code: string, message: string) {
    super(message)
    this.status = status
    this.code = code
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`/api/v2${path}`, {
    credentials: 'include',
    ...init,
    headers: { Accept: 'application/json', ...(init.body ? { 'Content-Type': 'application/json' } : {}), ...init.headers },
  })
  const text = await res.text()
  const body: unknown = text ? JSON.parse(text) : null
  if (!res.ok) {
    const err = (body as ApiErrorBody | null)?.error
    throw new ApiError(res.status, err?.code ?? 'http_error', err?.message ?? `Request failed (${res.status})`)
  }
  return body as T
}

export const post = <T>(path: string, data: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(data) })

export interface Me {
  user: { id: number; email: string; username: string; display_name: string | null; role: 'user' | 'admin'; created_at: string }
  plan: { code: 'free' | 'pro' | 'trader'; name: string; status: string; trial_ends_at: string | null; current_period_end: string | null }
  entitlements: Record<string, unknown>
  /** Launch offer: while active every account gets the top plan and checkout is closed. */
  promo?: Promo
}
export interface Promo { active: boolean; until: string | null }
export const promoUntil = (p?: Promo | null) => p?.until ? new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(p.until)) : null
